import React, { useEffect, useRef, useState } from 'react';
import tapIcon from '../../services/TapIcon';
import { useSelector } from 'react-redux';
import Loader from "../../components/ui/Loader/Loader";
import { Helmet } from 'react-helmet';
import HttpAPICall from "../../services/HttpAPICall";
import DatePicker from "react-datepicker";
import { toast } from 'react-toastify';
import moment from 'moment';
import download from '../../services/DownloadFile';
 

const DeviceHistory = (props) => {
    const firstLoad = useRef(false);
    const [imei, setImei] = useState('');
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [loading, setLoading] = useState(false);
    const [deviceData, setDeviceData] = useState(null);
    const [mapAnimatedData, setMapAnimatedData] =   useState([]);
    const [downloading, setDownloading] = useState(false); 
 
    const access_token = useSelector(state => state.auth.access_token);

    useEffect(() => {
        const now = new Date();
        const twelveHoursAgo = new Date(now.getTime() - 12 * 60 * 60 * 1000);

        setStartDate(twelveHoursAgo);
        setEndDate(now);
    }, []);
    useEffect(() => {
        if (props.deviceData?.imei_no) {
            setImei(props.deviceData.imei_no);
        }
    }, [props.deviceData?.imei_no]);
    
    useEffect(() => {
        if (
            !firstLoad.current &&
            imei &&
            startDate &&
            endDate
        ) {
            firstLoad.current = true;
            fetchDeviceData(imei, startDate, endDate);
        }
    }, [imei, startDate, endDate]);

    const fetchDeviceData = (imei, startDate, endDate) => {
        setLoading(true);
        setDeviceData(null);

        const requestBody = {
            imeIs: [imei.trim()],
            startDate: new Date(startDate).toISOString(),
            endDate: new Date(endDate).toISOString()
        };

        HttpAPICall.withAthorization('POST', `https://api6.tappetbox.in/api/DeviceData/get-historical`, access_token, {}, requestBody, (resp) => {
            
            const mapAnimatedData           =   resp.data.map(d => {
                return { lat: d.latitude, lng: d.longitude }
            });
            setMapAnimatedData(mapAnimatedData);
            
            setDeviceData(resp.data);
            toast.success('Device data fetched successfully', { position: toast.POSITION.TOP_RIGHT });
        }, (error) => {
            toast.error('Failed to fetch device data', { position: toast.POSITION.TOP_RIGHT });
        }).finally(() => {
            setLoading(false);
        });
    };

    const handleDateTimeChange = (field, value) => {
        if (field === 'startDate') {
            setStartDate(value);
        } else if (field === 'endDate') {
            setEndDate(value);
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!imei) {
            toast.error('Please select an IMEI number', { position: toast.POSITION.TOP_RIGHT });
            return;
        }
        if (!startDate || !endDate) {
            toast.error('Please select both start and end dates', { position: toast.POSITION.TOP_RIGHT });
            return;
        }
        fetchDeviceData(imei, startDate, endDate);
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            handleSubmit(e);
        }
    };

    const handleLocationClick = (latitude, longitude) => {
        if (!latitude || !longitude || isNaN(parseFloat(latitude)) || isNaN(parseFloat(longitude))) {
            toast.error('Invalid location coordinates', { position: toast.POSITION.TOP_RIGHT });
            return;
        }

        const mapsUrl = `https://www.google.com/maps?q=${latitude},${longitude}`;
        window.open(mapsUrl, '_blank', 'noopener,noreferrer');
    };

    const formatValue = (key, value, record = null) => {
        if (value === null || value === undefined) return 'N/A';

        if (typeof value === 'boolean') {
            return value ? 'Yes' : 'No';
        }

        if (typeof value === 'number') {
            switch (key) {
                case 'speed':
                    return `${value} km/h`;
                case 'direction':
                    return `${value}°`;
                case 'altitude':
                    return `${value} m`;
                case 'externalVoltage':
                case 'batteryVoltage':
                    return `${value} V`;
                default:
                    return value.toString();
            }
        }


        if ((key.toLowerCase().includes('time') || key.toLowerCase().includes('date')) && !isNaN(Date.parse(value))) {
            return moment(value).format('DD-MMM-YYYY HH:mm:ss');
        }

        if (key.toLowerCase().includes('imei') && record) {
            const hasValidLocation = record.latitude && record.longitude &&
                !isNaN(parseFloat(record.latitude)) && !isNaN(parseFloat(record.longitude));

            if (hasValidLocation) {
                return (
                    <button
                        className="btn btn-link p-0 text-primary text-decoration-none"
                        onClick={() => handleLocationClick(
                            record.latitude,
                            record.longitude,
                        )}
                    >
                        {value}
                    </button>
                );
            }
        }

        return value.toString();
    };
   const handleCsvDownload = () => {
    if (!deviceData || !Array.isArray(deviceData) || deviceData.length === 0) {
        toast.error('No data available to download', { position: toast.POSITION.TOP_RIGHT });
        return;
    }

    setDownloading(true);

    const requestBody = {
        imeIs: [imei.trim()],
        startDate: new Date(startDate).toISOString(),
        endDate: new Date(endDate).toISOString()
    };

    HttpAPICall.withAthorization(
        'POST',
        'https://api6.tappetbox.in/api/DeviceData/get-historical-csv',
        access_token,
        {},
        requestBody,
        (resp) => {
            if (resp?.data) {
                const csvData = typeof resp.data === 'string' ? resp.data : JSON.stringify(resp.data);
                const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
                const url = URL.createObjectURL(blob);
                download.file(url, 'CSV downloaded successfully!');
                setTimeout(() => URL.revokeObjectURL(url), 5000);
            } else {
                toast.error('No data received from server', { position: toast.POSITION.TOP_RIGHT });
            }
        },
        (error) => {
            console.error('CSV Download Error:', error);
            toast.error('Failed to download CSV', { position: toast.POSITION.TOP_RIGHT });
        }
    ).finally(() => {
        setDownloading(false);
    });
};
    const renderDeviceData = () => {
        const dataToUse = deviceData;
    

    if (!dataToUse) return null;

    const excludedKeys = ['deviceAsset', 'extra'];

    const filterKeys = (obj) => {
        return Object.fromEntries(
            Object.entries(obj).filter(([key]) => !excludedKeys.includes(key))
        );
    };

    if (Array.isArray(dataToUse)) {
        if (dataToUse.length === 0) {
            return (
                <div className="row mt-4">
                    <div className="col-12">
                        <h6> No data found for the selected criteria.</h6>
                    </div>
                </div>
            );
        }

        // Create the first record with fuelVoltage and fuelLiters extracted from extra
        const filteredFirstRecord = {
            ...filterKeys(dataToUse[0]),
            fuelVoltage: dataToUse[0]?.extra?.fuelVoltage ?? 'N/A',
            fuelLiters: dataToUse[0]?.extra?.fuelLiters ?? 'N/A',
        };

        return (
            <div className="row my-4">
                <div className="col-12">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <h5 className="card-title mb-0">
                            Response
                        </h5>
                        <button
                            onClick={handleCsvDownload}
                            disabled={loading || downloading || !deviceData || deviceData.length === 0}
                            className="btn btn-secondary"
                        >
                            <tapIcon.FontAwesomeIcon icon={tapIcon.faDownload} />
                            {downloading ? ' Downloading...' : ' Download CSV'}
                        </button>
                    </div>

                    <div className="card mt-3">
                        <div className="card-body p-0">
                            <div className="table-responsive" style={{
                                scrollbarWidth: 'thin',
                                maxHeight: '500px',
                                overflowY: 'auto',
                                overflowX: 'auto'
                            }}>
                                <table className="table table-hover table-bordered table-fixed">
                                    <thead className="table-secondary" style={{
                                        position: 'sticky',
                                        top: 0,
                                        zIndex: 1,
                                        backgroundColor: '#f8f9fa'
                                    }}>
                                        <tr>
                                            {Object.keys(filteredFirstRecord).map((key) => (
                                                <th key={key} className="text-nowrap text-center">
                                                    {key}
                                                </th>
                                            ))}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {dataToUse.map((record, index) => {
                                            const filteredRecord = {
                                                ...filterKeys(record),
                                                fuelVoltage: record?.extra?.fuelVoltage ?? 'N/A',
                                                fuelLiters: record?.extra?.fuelLiters ?? 'N/A',
                                            };
                                            return (
                                                <tr key={index}>
                                                    {Object.entries(filteredRecord).map(([key, value]) => (
                                                        <td key={key} className="text-nowrap text-center">
                                                            {formatValue(key, value, record)}
                                                        </td>
                                                    ))}
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
    }
    return (
        <>
            <Helmet><title>Device History</title></Helmet>
            <div className="container-fluid">
                <div className="page_containt row pl2">
                    <div className="pageTbl col-12 pl4">
                        <div className="bg-white p-3">
                            {props?.deviceData?.asset &&
                                <table className="table table-hover table-borderless mt-2">
                                    <tbody>
                                        <tr>
                                            <td className="details-label" style={{ "width": "34%" }}>Asset </td>
                                            <td className="details-name" style={{ "width": "66%" }}>{props?.deviceData?.asset?.asset_name || "-"}({props?.deviceData?.asset?.asset_nickname || "-"})</td>
                                        </tr>
                                        <tr>
                                            <td className="details-label" style={{ "width": "34%" }}> Group</td>
                                            <td className="details-name" style={{ "width": "66%" }}>{props?.deviceData?.group?.group_name || "-"}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            }
                            <form onSubmit={handleSubmit}>
                                <div className="row align-items-center my-3">
                                    <div className="col-sm-4">
                                        <label htmlFor="imei" className="form-label require">IMEI</label>
                                    </div>
                                    <div className="col-sm-4">
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={imei || ''}
                                            readOnly
                                            disabled
                                            placeholder="IMEI Number"
                                        />
                                    </div>
                                </div>

                                <div className="row align-items-center my-3">
                                    <div className="col-sm-4">
                                        <label htmlFor="startDate" className="form-label require">Start Date</label>
                                    </div>
                                    <div className="col-sm-4">
                                        <DatePicker
                                            selected={startDate}
                                            onChange={(value) => handleDateTimeChange('startDate', value)}
                                            dateFormat="dd-MMM-yyyy HH:mm"
                                            className="form-control"
                                            showMonthDropdown
                                            showYearDropdown
                                            showTimeSelect
                                            timeFormat="HH:mm"
                                            timeIntervals={15}
                                            timeCaption="Time"
                                            autoComplete="off"
                                            scrollMonthYearDropdown
                                            required={true}
                                            placeholderText="Please Enter Start Date & Time"
                                        />
                                    </div>
                                </div>

                                <div className="row align-items-center my-3">
                                    <div className="col-sm-4">
                                        <label htmlFor="endDate" className="form-label require">End Date</label>
                                    </div>
                                    <div className="col-sm-4">
                                        <DatePicker
                                            selected={endDate}
                                            onChange={(value) => handleDateTimeChange('endDate', value)}
                                            dateFormat="dd-MMM-yyyy HH:mm"
                                            className="form-control"
                                            showMonthDropdown
                                            showYearDropdown
                                            showTimeSelect
                                            timeFormat="HH:mm"
                                            timeIntervals={15}
                                            timeCaption="Time"
                                            autoComplete="off"
                                            scrollMonthYearDropdown
                                            required={true}
                                            placeholderText="Please Enter End Date & Time"
                                        />
                                    </div>
                                </div>

                                <div className="row align-items-center my-3">
                                    <div className="col-sm-7"></div>
                                    <div className="col-sm-2">
                                        <button
                                            type="submit"
                                            disabled={loading}
                                            className="btn btn-primary "
                                        >
                                            GO
                                            {loading && (
                                                <>
                                                    <tapIcon.FontAwesomeIcon icon={tapIcon.faSyncAlt} className="fa-spin ms-2" />
                                                </>
                                            )}
                                        </button>
                                    </div>
                                </div>
                            </form>
                            {loading && <Loader />}
                            {renderDeviceData()}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default DeviceHistory;